<a mat-list-item (click)="toggle()" >
        <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}">
            <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Gestão Financeira">
                <mat-icon>account_balance</mat-icon>
                <span *ngIf="menuPrincipalService.expandido"  class="nav-caption">Gestão Financeira</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="start stretch">
                <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
            </div>
        </div>
    </a>
    <mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

        <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

            <!-- MOVIMENTACOES -->
            <sub-menu *ngIf="verificaAcesso(getModulos().MOVIMENTACOES)" icone="list_alt" titulo="Movimentações" rota="movimentacoes" toolTip="Movimentações"></sub-menu>

            <!-- SALDOS_CONTAS_BANCARIA -->
            <sub-menu  *ngIf="verificaAcesso(getModulos().SALDOS_CONTAS_BANCARIA)" icone="monetization_on" titulo="Saldos de contas bancárias" rota="saldoscontasbancaria" toolTip="Saldos de contas bancárias"></sub-menu>

            <!-- TRANSFERENCIA_VALORES -->
            <sub-menu *ngIf="verificaAcesso(getModulos().TRANSFERENCIA_VALORES)" icone="compare_arrows" titulo="Transferência de valores" rota="transferenciavalores" toolTip="Transferência de valores"></sub-menu>

            <!-- CONCILIACAO_BANCARIA -->
            <sub-menu *ngIf="verificaAcesso(getModulos().CONCILIACAO_BANCARIA)" icone="rule" titulo="Conciliação Bancária" rota="conciliacao" toolTip="Conciliação Bancária"></sub-menu>

            <!-- PROVISAO -->
            <sub-menu *ngIf="verificaAcesso(getModulos().PROVISAO)" icone="local_atm" titulo="Provisão" rota="provisao" toolTip="Provisão"></sub-menu>

            <!-- MOVIMENTACOES_CONTABIES -->
            <sub-menu *ngIf="verificaAcesso(getModulos().MOVIMENTACOES_CONTABIES)" icone="price_check" titulo="Movimentações Contábeis" rota="movimentacoescontabeis" toolTip="Movimentações Contábeis"></sub-menu>

            <!-- ARQUIVO_EXTRATO -->
            <sub-menu *ngIf="verificaAcesso(getModulos().ARQUIVO_EXTRATO)" icone="file_present"
                      titulo="Importação de Arquivo de Extrato" rota="arquivo-extrato"
                      toolTip="Importação de Arquivo de Extrato"></sub-menu>

            <!-- ARGUMENTOS_CATEGORIA_CONTABIL -->
            <sub-menu *ngIf="verificaAcesso(getModulos().CONJUNTO_CATEGORIA_CONTABIL)" icone="list_alt"
                      rota="conjuntos-categoria-contabil" titulo="Conjuntos de Contas Contábeis"
                      toolTip="Conjuntos de Contas Contábeis"></sub-menu>

            <!-- RELATORIOS -->
            <sub-menu-relatorio-financeiro *ngIf="verificaAcesso(getModulos().RELATORIO_GESTAO_FINANCEIRA)"></sub-menu-relatorio-financeiro>

            <!-- TABELAS REFERENCIA -->
            <tb-referencia-financeiro></tb-referencia-financeiro>

        </div>
    </mat-nav-list>

